var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9417 8.62668C12.9417 7.91677 13.5119 7.34662 14.2234 7.34662C14.9428 7.34662 15.5003 7.91677 15.5003 8.62668C15.5003 9.33659 14.9428 9.89562 14.2234 9.89562C13.5119 9.89562 12.9417 9.33659 12.9417 8.62668ZM11.5457 19.9916C11.5457 19.6311 11.838 19.3404 12.2096 19.3404H13.8851V13.3134H12.362C11.9888 13.3134 11.6982 13.0338 11.6982 12.6622C11.6982 12.3144 11.9888 12.0238 12.362 12.0238H14.595C15.0603 12.0238 15.3033 12.3493 15.3033 12.8274V19.3404H16.9788C17.3505 19.3404 17.6411 19.6311 17.6411 19.9916C17.6411 20.3521 17.3505 20.6316 16.9788 20.6316H12.2096C11.838 20.6316 11.5457 20.3521 11.5457 19.9916ZM24.4591 14.2901C24.4464 8.66003 19.9106 4.13693 14.2806 4.13693C8.66162 4.13693 4.13693 8.66003 4.13693 14.2901C4.13693 19.9201 8.66162 24.4591 14.2917 24.4591C19.9217 24.4591 24.4591 19.9201 24.4591 14.2901ZM2.625 14.2901C2.625 7.90565 7.89454 2.625 14.2806 2.625C20.6777 2.625 25.9583 7.90565 25.9583 14.2901C25.9583 20.6777 20.6777 25.9583 14.2917 25.9583C7.90565 25.9583 2.625 20.6777 2.625 14.2901Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacion);
export default __webpack_public_path__ + "static/media/informacion.d29104543160ab6ec22397f60d35a2dc.svg";
export { ForwardRef as ReactComponent };